import { FormattedMessage } from 'react-intl';
import { CheckboxElement } from 'react-hook-form-mui';

interface SegmentationHideColumnOptionProps {
  /** Form field path for the hide-column value (e.g. data.sections.0.segmentation.hideColumn). */
  name: string;
}

/**
 * Checkbox option to hide the segmentation column in the final report output.
 * Must be used inside a FormContainer (react-hook-form-mui).
 */
export function SegmentationHideColumnOption({ name }: SegmentationHideColumnOptionProps) {
  return (
    <CheckboxElement
      name={name}
      label={
        <FormattedMessage
          id="audit.reportDefinitions.segmentation.hideColumn"
          defaultMessage="Ocultar esta columna en el reporte"
        />
      }
      size="small"
    />
  );
}
